import { theme } from '@features/lci-report/domain/theme';
import { contentSlideHeader } from '@features/lci-report/utils';
import { Slide, composeSlides, parseTags } from '@features/powerpoint';
import { TITLE } from '../../../shared/dark-background-slide-master';
import { notes } from './components/notes';
import { dimensionTable } from './components/dimension-table';

const CONTENT_AREA_WIDTH = 11.82;
const TABLE_Y = 2;
const LEFT_MARGIN = 0.74;
const NOTES_Y = TABLE_Y + 1.68;

const baseSlide = (): Slide => {
  return {
    slideMaster: TITLE,
    texts: [
      contentSlideHeader(parseTags('LCI<sup>®</sup> Guideline Minimums'), {
        color: theme.colors.white,
      }),
    ],
  };
};

export const dimensionSlide = () =>
  composeSlides(
    baseSlide(),
    dimensionTable({
      options: {
        rowH: 0.3,
        x: LEFT_MARGIN,
        y: TABLE_Y,
        w: CONTENT_AREA_WIDTH,
      },
    }),
    notes({
      options: {
        x: LEFT_MARGIN,
        y: NOTES_Y,
        h: 3,
        w: CONTENT_AREA_WIDTH,
        valign: 'top',
      },
    })
  );
